"use client";
import { useEffect } from 'react';

/**
 * FIX-45: registers public/sw.js so the site is installable as a PWA.
 *
 * Only registers in production - during local dev, hot-reloaded pages and a
 * cached service worker fight each other (classic "why isn't my change
 * showing up" PWA trap), and there is nothing to gain from installability
 * while iterating locally.
 */
export function RegisterServiceWorker() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Best-effort: a registration failure should never affect the rest of
      // the app.
    });
  }, []);

  return null;
}

export default RegisterServiceWorker;
